import {RecordKind} from 'core/Record';
import {hasType} from 'core/Record/hasType';
import {RecordsFilter} from './types';

export function filterByRecordKind(kind: RecordEntryKind): RecordsFilter {
  return function applyFilter(record: RecordEntry) {
    return hasType(record, kind);
  };
}

export const onlySpends = filterByRecordKind(RecordKind.Spend);
export const onlyIncomes = filterByRecordKind(RecordKind.Income);
